import React, { Component } from 'react';
import { firebaseRef } from './firebase.js';
import Indicator from './indicator';
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';
class NewUser extends Component {
  constructor(props){
    super(props);
    this.state = {
      fname: '',
      lname: '',
      loading: '',
      errorMassege: '',
      succesMassege: '',
      sameName: false,
      nameExists: false
    };
    this._handleFname = this._handleFname.bind(this);
    this._handleLname = this._handleLname.bind(this);
    this._logout = this._logout.bind(this);
    this._main = this._main.bind(this);
    this.afterCheck = this.afterCheck.bind(this);
    this.handleSameNameNo = this.handleSameNameNo.bind(this);
    this._userguide = this._userguide.bind(this);
  }

  componentWillMount(){
    var that=this;
    firebaseRef.auth().onAuthStateChanged(function(user) {
  if (user) {

  } else {
    // No user is signed in.
    that.props.history.push("/");
  }
});
}

  _handleFname(event) {
      this.setState({fname: event.target.value});
    }

  _handleLname(event) {
        this.setState({lname: event.target.value});
      }

    _newUser(){
      var that=this;
      this.setState({
        loading: <Indicator />,
        succesMassege: '',
      });
      if ((this.state.fname||this.state.lname) === '') {
        this.setState({
          errorMassege: 'Please fill in the required fileds.',
          loading: '',
        });
        return false
      }
      var regex = /[>/<:;{~`}!#%$)(_=+&^|]|[0-9]/g;
      if (regex.test(this.state.fname)||regex.test(this.state.lname)) {
        this.setState({
           errorMassege: 'First Name and Last Name Cannot contain special characters And numbers.',
           loading: '',
         });
          return false
      }
    var user = firebaseRef.auth().currentUser;
    var refMain = firebaseRef.database().ref("doctors/"+user.uid+"/users");
    refMain.off("value");
    var exists = false;
    refMain.once('value', function(snapshot){
      snapshot.forEach(function(childSnapshot) {
         var childData = childSnapshot.val();
         if(childData.fname === that.state.fname && (childData.lname === that.state.lname)){
            exists = true;
        }
      })
    }).then(function(){
        if (exists) {
            that.setState({
              loading: '',
              sameName: true
            })
        }else{
          that.afterCheck();
        }
    });

}

_logout(){
  var that=this;
  firebaseRef.auth().signOut().then(function() {
    that.props.history.push("/");
}).catch(function(error) {
  alert("An Errror acurred Please Try Agian");
});
}

_main(){
  this.props.history.push("/patient/none/none");
}

handleSameNameNo(){
  this.setState({
    fname: '',
    lname: '',
    loading: '',
    errorMassege: '',
    succesMassege: '',
    sameName: false
  })
}

afterCheck(){
  var that=this;
  if ((this.state.fname||this.state.lname) === '') {
    this.setState({
      errorMassege: 'Please fill in the required fileds.',
      loading: '',
    });
    return false
  }
  this.setState({ sameName: false });
  var user = firebaseRef.auth().currentUser;
  var refMain = firebaseRef.database().ref("doctors/"+user.uid+"/users");
  refMain.push({
      fname: that.state.fname,
      lname: that.state.lname,
  }).then(function(){
    that.setState({
      loading: '',
      succesMassege: 'Paitent Added Succesfully',
      fname: '',
      lname: '',
    })
  }).catch(function(){
      that.setState({
        errorMassege: 'Something went wrong, Please submit a new information or check your inputs.'
      })
  });
}

_userguide(){
  this.props.history.push("/userguide");
}

  render() {
       return (
         <div id="new-user" align="center">
         <div id="header">
           <h2 className="header-title">Chirosystem</h2>
            <div className="header-links">
           <button type="button" onClick={this._main} className="logout-button">Main</button>
           <button type="button" onClick={this._logout} className="logout-button">Logout</button>
           <button type="button" onClick={this._userguide} className="logout-button">Guide</button>
           </div>
         </div>
         <div>
         <form className="login-signup-container">
         <div>
           <input type="text" className="text-inputs" placeholder="First Name" value={this.state.fname} onChange={this._handleFname}/>
           </div>
           <div>
           <input type="text" className="text-inputs" placeholder="Last Name" value={this.state.lname} onChange={this._handleLname}/>
           </div>
           <div>
           <input type="button" className="button-forms" value="Create a New Paitent" style={{backgroundColor: 'green', borderColor: 'green'}} onClick={this._newUser.bind(this)}/>
           </div>
             <div>
               <p style={{color: "red"}}>{this.state.errorMassege}</p>
               <p style={{color: "green"}}>{this.state.succesMassege}</p>
               <div>{this.state.loading}</div>
             </div>
             <div className="same-name">
             {this.state.sameName ? (
               <div className="same-name-container">
               <div className="same-name-header">
               <FaExclamationTriangle color="white" size={40}/>
                <h3>Theres alerdy a paitent with this First and Last name you sure you want to continue?</h3>
                </div>
               <div>
                <button onClick={this.afterCheck} className="same-name-button">Yes</button>
                <button onClick={this.handleSameNameNo} className="same-name-button">No</button>
                </div>
               </div>
             ) : (
               <div></div>
             )}
             </div>
         </form>
         </div>
         </div>
       );
     }
  }


export default NewUser;



// WEBPACK FOOTER //
// ./src/routes/newUser.js